import { render, staticRenderFns } from "./BtnLoading.vue?vue&type=template&id=021cca68&"
import script from "./BtnLoading.vue?vue&type=script&lang=js&"
export * from "./BtnLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports